import type { i18n, LanguageDetectorAsyncModule } from 'i18next';
import i18next from 'i18next';
import XHR from 'i18next-xhr-backend';
import { getBootLocalePromise } from 'modules/locale/boot';
import { URL_LOCALES } from 'modules/locale/paths';
import { initReactI18next } from 'react-i18next';

export const availableLng = URL_LOCALES;

export const fallbackLng = 'en';

let i18nInstance: i18n;

const I18nInstanceSetter = {
  type: '3rdParty' as const,

  init(instance: i18n) {
    i18nInstance = instance;
  },
};

export { i18nInstance };

const CustomLanguageDetector: LanguageDetectorAsyncModule = {
  type: 'languageDetector' as const,
  async: true,
  init() {},
  detect(callback: (lng: string) => void) {
    getBootLocalePromise().then(callback);
  },
  // No-op: i18next would persist the default locale on init.
  cacheUserLanguage() {},
};

i18next.on('languageChanged', (lng) => {});

i18next.on('initialized', () => {
  console.log('Localization was initialized');
});

i18next.on('failedLoading', (lng, ns, msg) => {});

export default i18next
  .use(CustomLanguageDetector)
  .use(XHR)
  .use(I18nInstanceSetter)
  .use(initReactI18next)
  .init({
    whitelist: availableLng,
    fallbackLng,
    load: 'currentOnly',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    ns: [
      'glossary',
      'common',
      'validation',
      'deposits',
      'jackpot',
      'mobileApp',
      'emailNDBModal',
      'promotions',
    ],
    defaultNS: 'common',
    debug: false,
    react: { useSuspense: false },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });
